import { getSiteProps } from "@/utils";

let host = "";
if (typeof window !== "undefined") {
  host = window.location.host;
}
export const siteProps = getSiteProps(host);
export const SITE_DOMAIN =
  typeof siteProps != "undefined" && typeof siteProps?.domain != "undefined"
    ? siteProps?.domain
    : "monsterindia.com";

export const CHANNEL = {
  INDIA_SPECFIC: {
    DOMAIN: "monsterindia.com",
    DOMAIN_NAME: "monsterindia",
    DOMAIN_KEY: "monsterindia",
    TEXT_NAME: "Monster India",
    API_DOMAIN: "monsterindia.com",
    MEDIA_DOMAIN: "monsterindia.com",
  },
  INDIA: {
    DOMAIN: SITE_DOMAIN == "foundit.in" ? SITE_DOMAIN : "monsterindia.com",
    DOMAIN_NAME: SITE_DOMAIN == "foundit.in" ? SITE_DOMAIN : "monsterindia",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "India",
    API_DOMAIN: SITE_DOMAIN == "foundit.in" ? SITE_DOMAIN : "monsterindia.com",
    MEDIA_DOMAIN:
      SITE_DOMAIN == "foundit.in" ? SITE_DOMAIN : "monsterindia.com",
    SITE_CONTEXT: "rexmonster",
  },
  GULF: {
    DOMAIN: SITE_DOMAIN == "founditgulf.com" ? SITE_DOMAIN : "monstergulf.com", //"founditgulf.com
    DOMAIN_NAME:
      SITE_DOMAIN == "founditgulf.com" ? SITE_DOMAIN : "monstergulf.com",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Gulf",
    API_DOMAIN:
      SITE_DOMAIN == "founditgulf.com" ? SITE_DOMAIN : "monstergulf.com",
    MEDIA_DOMAIN:
      SITE_DOMAIN == "founditgulf.com" ? SITE_DOMAIN : "monstergulf.com",
    SITE_CONTEXT: "monstergulf",
  },
  SINGAPORE: {
    DOMAIN: SITE_DOMAIN == "foundit.sg" ? SITE_DOMAIN : "monster.com.sg", //"foundit.sg
    DOMAIN_NAME: SITE_DOMAIN == "foundit.sg" ? SITE_DOMAIN : "monster.com.sg",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Singapore",
    API_DOMAIN: SITE_DOMAIN == "foundit.sg" ? SITE_DOMAIN : "monster.com.sg",
    MEDIA_DOMAIN: SITE_DOMAIN == "foundit.sg" ? SITE_DOMAIN : "monster.com.sg",
    SITE_CONTEXT: "monstersingapore",
  },
  THAILAND: {
    DOMAIN: SITE_DOMAIN == "monster.co.th" ? SITE_DOMAIN : "monster.co.th", //"foundit.th
    DOMAIN_NAME: SITE_DOMAIN == "monster.co.th" ? SITE_DOMAIN : "monster.co.th",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Thailand",
    API_DOMAIN: SITE_DOMAIN == "monster.co.th" ? SITE_DOMAIN : "monster.co.th",
    MEDIA_DOMAIN:
      SITE_DOMAIN == "monster.co.th" ? SITE_DOMAIN : "monster.co.th",
    SITE_CONTEXT: "monsterthailand",
  },
  PHILIPPINES: {
    DOMAIN: SITE_DOMAIN == "foundit.com.ph" ? SITE_DOMAIN : "monster.com.ph", //"foundit.com.ph
    DOMAIN_NAME:
      SITE_DOMAIN == "foundit.com.ph" ? SITE_DOMAIN : "monster.com.ph",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Philippines",
    API_DOMAIN:
      SITE_DOMAIN == "foundit.com.ph" ? SITE_DOMAIN : "monster.com.ph",
    MEDIA_DOMAIN:
      SITE_DOMAIN == "foundit.com.ph" ? SITE_DOMAIN : "monster.com.ph",
    SITE_CONTEXT: "monsterphilippines",
  },
  VIETNAM: {
    DOMAIN: SITE_DOMAIN == "monster.com.vn" ? SITE_DOMAIN : "monster.com.vn", //"foundit.vn
    DOMAIN_NAME:
      SITE_DOMAIN == "monster.com.vn" ? SITE_DOMAIN : "monster.com.vn",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Vietnam",
    API_DOMAIN:
      SITE_DOMAIN == "monster.com.vn" ? SITE_DOMAIN : "monster.com.vn",
    MEDIA_DOMAIN:
      SITE_DOMAIN == "monster.com.vn" ? SITE_DOMAIN : "monster.com.vn",
    SITE_CONTEXT: "monstervietnam",
  },
  MALAYSIA: {
    DOMAIN: SITE_DOMAIN == "foundit.my" ? SITE_DOMAIN : "monster.com.my", //"foundit.my
    DOMAIN_NAME: SITE_DOMAIN == "foundit.my" ? SITE_DOMAIN : "monster.com.my",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Malaysia",
    API_DOMAIN: SITE_DOMAIN == "foundit.my" ? SITE_DOMAIN : "monster.com.my",
    MEDIA_DOMAIN: SITE_DOMAIN == "foundit.my" ? SITE_DOMAIN : "monster.com.my",
    SITE_CONTEXT: "monstermalaysia",
  },
  INDONESIA: {
    DOMAIN: SITE_DOMAIN == "foundit.id" ? SITE_DOMAIN : "monster.co.id", //"foundit.id
    DOMAIN_NAME: SITE_DOMAIN == "foundit.id" ? SITE_DOMAIN : "monster.co.id",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Indonesia",
    API_DOMAIN: SITE_DOMAIN == "foundit.id" ? SITE_DOMAIN : "monster.co.id",
    MEDIA_DOMAIN: SITE_DOMAIN == "foundit.id" ? SITE_DOMAIN : "monster.co.id",
    SITE_CONTEXT: "monsterindonesia",
  },
  HONGKONG: {
    DOMAIN: SITE_DOMAIN == "foundit.hk" ? SITE_DOMAIN : "monster.com.hk", //"foundit.hk
    DOMAIN_NAME: SITE_DOMAIN == "foundit.hk" ? SITE_DOMAIN : "monster.com.hk",
    TEXT_NAME: "Monster India",
    CHANNEL_NAME: "Hongkong",
    API_DOMAIN: SITE_DOMAIN == "foundit.hk" ? SITE_DOMAIN : "monster.com.hk",
    MEDIA_DOMAIN: SITE_DOMAIN == "foundit.hk" ? SITE_DOMAIN : "monster.com.hk",
    SITE_CONTEXT: "monsterhongkong",
  },
};
export const socialLoginConst = {
  fbAppId: "2202822979737806",
  googleClientId:
    "591528984509-5odtn52njfsg44lqftrpnv0pudm9u8kc.apps.googleusercontent.com",
  googleClientSecret: "ZhSfZNH8PQQ9l5TUwU6lwZMl",
  socialRegisterUrl:
    "https://rfs." +
    CHANNEL.INDIA_SPECFIC.DOMAIN +
    "/falcon/api/public/users/v1/register/personal-details",
  socialLoginUrl: "https://rfs." + CHANNEL.INDIA_SPECFIC.DOMAIN + "/rio/login",
  fbAppIds: {
    IN: "2202822979737806",
    SA: "776627922732996",
    HK: "2402443739779164",
    SG: "2321740241404008",
    PH: "422628918571957",
    TH: "434863447348842",
    VN: "629624047504556",
    ID: "301538607398265",
    MY: "688558738251762",
  },
};
